import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import store from '../store';

let stompClient = null;

export function Connect(url, userProfile) {
  const useWSS = window.location.protocol === 'https:';

  const socket = new SockJS(url + `/ws`,null,{transports:'websocket'});
  stompClient = Stomp.over(socket);
  let userName = userProfile.userName;
  stompClient.debug = () => {};

  stompClient.connect({}, () => {
    SubscribeComment(userName);
    SubscribeMove(userName);
    SubscribeNotification(userName);
    SubscribeOnline();
    SubscribeTask(userName);
    SubscribeColumn(userName);
    SubscribeAction(userName);
    SubscribeUpdate(userName);
  });
}

export function Disconnect() {
  stompClient.disconnect();
}

function SubscribeNotification(userName) {
  stompClient.subscribe(`/user/${userName}/queue/reply`, (message) => {
    store.commit('setSocketNotification', JSON.parse(message.body));
  });
}

function SubscribeOnline() {
  stompClient.subscribe('/topic/online-users', (message) => {
    store.commit('setSocketOnline', JSON.parse(message.body));
  });
}

function SubscribeTask(userName) {
  stompClient.subscribe(`/user/${userName}/task/reply`, (message) => {
    store.commit('setSocketTask', JSON.parse(message.body));
  });
}

function SubscribeColumn(userName) {
  stompClient.subscribe(`/user/${userName}/column/reply`, (message) => {
    store.commit('setSocketColumn', JSON.parse(message.body));
  });
}
function SubscribeMove(userName) {
  stompClient.subscribe(`/user/${userName}/task/move`, (message) => {
    store.commit('setSocketMove', JSON.parse(message.body));
  });
}
function SubscribeUpdate(userName) {
  stompClient.subscribe(`/user/${userName}/task/update`, (message) => {
    store.commit('setSocketUpdate', JSON.parse(message.body));
  });
}
function SubscribeComment(userName) {
  stompClient.subscribe(`/user/${userName}/task/comment`, (message) => {
    store.commit('setSocketComment', JSON.parse(message.body));
  });
}
function SubscribeAction(userName) {
  stompClient.subscribe(`/user/${userName}/action/reply`, (message) => {
    store.commit('setSocketAction', JSON.parse(message.body));
  });
}

export default {
  Connect,
  Disconnect
};
